"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomIconSizeEnum = void 0;
var CustomIconSizeEnum;
(function (CustomIconSizeEnum) {
    CustomIconSizeEnum["XXSMALL"] = "0.625rem";
    CustomIconSizeEnum["XSMALL"] = "0.75rem";
    CustomIconSizeEnum["SMALL"] = "0.875rem";
    CustomIconSizeEnum["LARGE"] = "1.25rem";
    CustomIconSizeEnum["XLARGE"] = "1.5rem";
    CustomIconSizeEnum["XXLARGE"] = "2rem";
    CustomIconSizeEnum["XXXLARGE"] = "2.25rem";
})(CustomIconSizeEnum || (exports.CustomIconSizeEnum = CustomIconSizeEnum = {}));
